<template>
  <!-- The sale list comes from user-setting/user, which needs get_user. -->
  <v-autocomplete
    v-if="canListSales"
    v-model="selectedSale"
    :items="sales"
    :label="label"
    clearable
    dense
    item-text="name"
    item-value="id"
    outlined
  />
</template>

<script>
import queryOptions from '../../Helpers/queryOption';

export default {
  props: {
    label: {
      default: 'ເລືອກເຊວທີ່ກ່ຽວຂ້ອງss',
      type: String,
    },
    firstSale: {
      default: '',
    },
  },
  data() {
    return {
      salesData: [],
      selectedSale: '',
    };
  },
  computed: {
    canListSales() {
      return Boolean(this.$can('get_user'));
    },
    sales() {
      const data = [];
      for (const item of this.salesData) {
        let name = '';
        if (item.name) name += `${item.name} `;
        if (item.phone) name += `${item.phone} `;
        if (item.emp_name) name += `${item.emp_name} `;
        if (item.emp_surname) name += `${item.emp_surname} `;
        if (item.emp_card_id) name += item.emp_card_id;
        data.push({
          name,
          id: item.id,
        });
      }
      return data;
    },
  },
  watch: {
    selectedSale() {
      this.$emit('input', this.selectedSale);
    },
  },
  async created() {
    if (!this.canListSales) return;
    await this.fetchSale();
    if (this.firstSale) this.selectedSale = typeof this.firstSale !== 'number' ? Number.parseInt(this.firstSale) : this.selectedSale;
  },
  methods: {
    async fetchSale() {
      try {
        const res = await this.$axios
          .get('user-setting/user', {
            params: queryOptions([
              { roles: ['sale', 'sale_admin', 'sale_register', 'sale_partner', 'sale_editor'] },
              { order_by: 'newest' },
            ]),
          });
        if (res.data.code === 200) {
          this.salesData = res.data.data.data || res.data.data;
        }
      } catch (error) {
        this.$store.commit('Toast_State', {
          value: true,
          color: 'error',
          msg: error.response
            ? error.response.data.message
            : 'Something went wrong',
        });
      }
    },
  },
};
</script>
